<template>
  <div>
            <b-card bg-variant="light">
  <b-form-group horizontal
                breakpoint="lg"
                label="Editing part"
                label-size="lg"
                label-class="font-weight-bold pt-0"
                class="mb-0">
    <b-form-group horizontal
                  label="Street:"
                  label-class="text-sm-right"
                  label-for="nestedStreet">
      <b-form-input id="nestedStreet"></b-form-input>
    </b-form-group>
    <b-form-group horizontal
                  label="City:"
                  label-class="text-sm-right"
                  label-for="nestedCity">
      <b-form-input id="nestedCity"></b-form-input>
    </b-form-group>
    <b-form-group horizontal
                  label="State:"
                  label-class="text-sm-right"
                  label-for="nestedState">
      <b-form-input id="nestedState"></b-form-input>
    </b-form-group>
    <b-form-group horizontal
                  label="Country:"
                  label-class="text-sm-right"
                  label-for="nestedCountry">
      <b-form-input id="nestedCountry"></b-form-input>
    </b-form-group>
    <b-form-group horizontal
                  label="Ship via:"
                  label-class="text-sm-right"
                  class="mb-0">
      <b-form-radio-group class="pt-2" :options="['Air', 'Courier', 'Mail']" />
    </b-form-group>
  </b-form-group>
</b-card>


 </div>
</template>

<script>

//import Right from '@/components/PartManager/Right/Right'
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: 'DashboardTable',
  components:{

  },
  data () {
    return {
      //msg: "message"
    }
  }
}
</script>


<style scoped>
.card{
  width: 50rem;
  margin-top: 130px;
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/DashboardTable.vue